import { Icon, IconProps } from '@cad-arc';
type CustomProps = {
    isActive?: boolean;
    isScheduledEvent?: boolean;
};

function getIconTypeAndColor(
    isActive: boolean | undefined,
    isScheduledEvent: boolean | undefined
): IconProps {
    if (isActive) {
        return { icon: 'Active', color: 'positive.default' };
    }

    if (isScheduledEvent) {
        return { icon: 'RecordsApproved', color: 'warning.default' };
    }

    return { icon: 'Closed', color: 'icon.default' };
}

export function EntityStatusIcon({
    isActive,
    isScheduledEvent,
    size,
}: CustomProps & Partial<IconProps>) {
    const { icon, color } = getIconTypeAndColor(isActive, isScheduledEvent);

    return (
        <Icon
            size={size}
            icon={icon}
            color={color}
            data-testid="entity-status-icon"
            data-active={isActive}
        />
    );
}
